var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-page"},[_c('div',{staticClass:"w-100 h-100 d-flex justify-content-center align-items-center flex-column"},[_c('div',{staticClass:"login_logo"},[_c('img',{attrs:{"src":_vm.current_url+'/assets/images/study-logo.png',"alt":"login"}})]),_vm._v(" "),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }